var map = {
	"./_fonts.scss": [
		1094,
		108
	],
	"./_fontsja-JP.scss": [
		1095,
		102
	],
	"./_fontsnewfont.scss": [
		640,
		29
	],
	"./_fontsth-TH.scss": [
		1096,
		109
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 998;
module.exports = webpackAsyncContext;